export const DATA_FORM_INPUT = (name: string) => ({
  dataTest: `form-${name}`,
});

export const DATA_FILTER_INPUT = (name: string) => ({
  dataTest: `filter-${name}`,
});
